import { render } from "./EditOddsTemplate.vue?vue&type=template&id=78c9749c"
import script from "./EditOddsTemplate.vue?vue&type=script&lang=js"
export * from "./EditOddsTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__